import { apiRequest } from './api'

// fetch + JSON + real errors. Every dashboard page used to do
//   const data = await (await apiRequest(url)).json(); setRows(data.rows || [])
// which turned a 401/403/500 into a convincing "nothing here" empty state (and
// in the rules editor, into a blank document that could be saved over the live
// page). apiJson throws an Error carrying the server's message + status instead.

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message)
    this.status = status
    this.data = data
  }
}

let onUnauthorized = null
export function setUnauthorizedHandler(fn) { onUnauthorized = fn }

export async function apiJson(endpoint, { method = 'GET', body, signal, headers } = {}) {
  const isForm = typeof FormData !== 'undefined' && body instanceof FormData
  let res
  try {
    res = await apiRequest(endpoint, {
      method,
      signal,
      headers,
      body: body === undefined ? undefined : isForm ? body : JSON.stringify(body),
    })
  } catch (err) {
    if (err?.name === 'AbortError') throw err
    throw new ApiError("Can't reach the server - check your connection and try again", 0)
  }
  const data = await res.json().catch(() => null)
  if (!res.ok) {
    if (res.status === 401 && onUnauthorized) onUnauthorized()
    const fallback = res.status === 403 ? "You don't have access to that"
      : res.status === 404 ? 'Not found'
      : res.status === 423 ? 'Staging is read-only'
      : res.status >= 500 ? 'The server had a problem - try again in a moment'
      : 'Request failed'
    throw new ApiError(data?.message || fallback, res.status, data)
  }
  return data
}
